import type { EventInfo } from '@models/Event'

import { request } from '../../../gateways/api'
import type { HoofdleidingProject } from '../types/HoofdleidingProject'

export { saveEvent }

const saveEvent = async (data: EventInfo): Promise<HoofdleidingProject> => {
  const { id } = data

  const result = await request({
    url: `/rest/project/${id}/event`,
    method: 'POST',
    data,
  })

  return result
}
